export const getPasswordScore = value => {
  let passwordScore = 0;
  if (/[a-z]/.test(value)) {
    passwordScore++;
  }
  if (/[A-Z]/.test(value)) {
    passwordScore++;
  }
  if (/[0-9]/.test(value)) {
    passwordScore++;
  }
  if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value)) {
    passwordScore++;
  }
  return passwordScore;
};
export const isValidPassword = value => {
  if (value.length > 25 || value.length < 8) {
    return false;
  }
  return getPasswordScore(value) >= 3;
};
export const isValidEmail = value => {
  return /^[a-zA-Z0-9.!$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
};
export const isValidPhone = value => {
  return value ? /^[(\d][\d\s-()]+[\d)]$/.test(value.trim()) : undefined;
};
export const isValidPhoneNew = value => {
  return value ? /^(\d{8}|\d{9}|\d{10}|\d{11})$/.test(value.trim()) : undefined;
};
export const isValidPhoneArea = value => {
  return value ? /^\+[0-9]{1,3}$/.test(value.trim()) : undefined;
};
export const isOnlyNumbers = value => {
  return /^[0-9]*$/.test(value.trim());
};
export const isValidBirthday = value => {
  return /^(?:19|20)\d{2}\/(?:0[1-9]|1[012])\/(?:3[01]|[12][0-9]|0[1-9])$/.test(value);
};
export const isValidPostalCode = value => {
  return /^[0-9a-zA-Z\s]+$/.test(value.trim());
};
